(function () {

  'use strict';

  angular.module('PrinterProperties')

    .constant('PRINTERS_PROPERTIES_TABS', [
      {
        icon: 'icon-gear',
        section: 'setup',
        caption: 'Setup',
        selected: false,
        show: true
      },
      {
        icon: 'icon-paper-tray-2',
        section: 'queues',
        caption: 'PrintQueues',
        selected: false,
        show: true
      },
      {
        icon: 'icon-access-card-2',
        section: 'printixGo',
        caption: 'Printix Go',
        selected: false,
        show: true
      },
      {
        icon: 'icon-diagnostics',
        section: 'diagnostics',
        caption: 'Diagnostics',
        selected: false,
        show: true
      },
      {
        icon: 'icon-history',
        section: 'history',
        caption: 'History',
        selected: false,
        show: true
      }
    ])

    .controller('PrinterPropertiesController', function (
      $rootScope, $scope, $location, URLS, $filter, PrinterListService, toastr,
      PRINTER_TYPES, $routeParams, URL_PARAMS, TenantListService, NetworkListService, $ngBootbox,
      $http, EventServiceEvents, NetworkListPaging, PRINTERS_PROPERTIES_TABS, EventHandlerService,
      $timeout, SnmpConfigurationService, PrintQueueListService, currentTenant, enums) {

      $scope.tabs = PRINTERS_PROPERTIES_TABS;
      $scope.printer = null;
      $scope.printerOriginal = null;
      $scope.getLocationEnabled = false;
      $scope.urls = URLS;
      $scope.geoLocationRegEx = /^[0-9.]{1,10}$/;
      $scope.printerTypes = PRINTER_TYPES;
      $scope.printerPropertiesForm = {};
      $scope.tenantListService = TenantListService;
      $scope.networkListService = null;
      $scope.helpCaption = null;
      $scope.networkListPaging = new NetworkListPaging();
      $scope.eventHandlerService = EventHandlerService;
      $scope.selectedNetwork = null;
      $scope.statusPrinter = null;
      $scope.me = null;
      $scope.isThisResourceMine = true;
      $scope.queueNameInvalid = false;
      $scope.tenant = currentTenant;
      $scope.thresholdToSwitchCreatedTimeFormat = 6;
      $scope.error = null;

      (function () {
        initEventHandler();
        setListeners();
        getDefaultSnmpConfiguration();
      })();

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
          getPrinter();
        }
      });

      function initEventHandler() {
        $scope.eventHandlerService.deRegisterListeners();
      };

      $scope.setSection = function (section) {
        $scope.showSection = section;
        $scope.closeAllMenues();
        const url = $location.path();
        $location.path(url, false).search({ printerSection: section });
      };

      $scope.$watch(function () {
        return $scope.showSection;
      }, function () {
        if ($scope.showSection) {
          switch ($scope.showSection) {
            case 'setup':
              $scope.helpCaption = 'HelpPrinterPropertiesSetup';
              break;
            case 'queues':
              $scope.helpCaption = 'HelpPrinterPropertiesPrintQueues';
              break;
            case 'printixGo':
              $scope.helpCaption = 'HelpPrinterPropertiesPrintixGo';
              break;
            case 'diagnostics':
              $scope.helpCaption = 'HelpPrinterPropertiesDiagnostics';
              break;
            case 'history':
              $scope.helpCaption = 'HelpPrinterPropertiesHistory';
              break;
          }
        }
      }, true);

      (function () {
        if ($routeParams.printerSection) {
          $scope.showSection = $routeParams.printerSection;
        } else {
          $scope.showSection = 'setup';
        }
      })();

      $scope.updatePrinterAttributes = function () {
        const url = $scope.printer.info._links['px:updateDeviceAttributes'].href;
        $ngBootbox.confirm($filter('translate')('ContactPrinterWarning')).then(function () {
          $http.get(url).then(function (response) {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error) {});
        }).catch(function(error) {});
      };

      $scope.markerDragEnd = function ($event) {
        $scope.$apply(function () {
          if (!$scope.printer.info.geoLocation) {
            $scope.printer.info.geoLocation = {};
          }
          $scope.printer.info.geoLocation.lat = $event.latLng.lat().toString().substring(0, 10);
          $scope.printer.info.geoLocation.lon = $event.latLng.lng().toString().substring(0, 10);
          $scope.savePrinter();
        });
      };

      $scope.fillCurrentLocation = function () {
        $scope.enableSpinner = true;
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            const lat = position.coords.latitude.toString().substring(0, 10);
            const lon = position.coords.longitude.toString().substring(0, 10);
            $scope.geoLocationDisabled = false;
            $scope.$apply(function () {
              $scope.printer.info.geoLocation = {
                lat: lat,
                lon: lon
              };
              $scope.enableSpinner = false;
              $scope.savePrinter();
              refreshGeoLocationInPopup(lat, lon);
            });
          }, function () {
            $scope.geoLocationDisabled = true;
          });
        }
      };

      function refreshGeoLocationInPopup(lat, lon) {
        if ($scope.printerGeolocationConfiguration) {
          $scope.printerGeolocationConfiguration.inputDataObject[0].value = lat;
          $scope.printerGeolocationConfiguration.inputDataObject[1].value = lon;
        }
      }

      $scope.printPrinterIdSign = function () {
        $location.path(URLS.PRINTER_ID_SIGN.replace(URL_PARAMS.PRINTER_URL.LOCATION, $scope.printer.customProperties.id));
      };

      $scope.watchGeoLocationEnabled = function () {
        if (!$scope.getLocationEnabled && $scope.printerOriginal.info.geoLocation) {
          delete $scope.printer.info.geoLocation;
          $scope.savePrinter();
        } else {
          $scope.fillCurrentLocation();
        }
      };

      function getNameSuggestions() {
        $http.get($scope.printer.info._links['px:editsuggestions'].href).then(function (response) {
          $scope.namesArray = [];

          for (let i = 0; i < response.data.name.newValues.length; i++) {
            const nameObject = {
              name: response.data.name.newValues[i],
              id: i + 1
            };
            $scope.namesArray.push(nameObject);
          }
        }).catch(function(error) {});
      }

      // Queue **********************************************
      $scope.checkAllCheckboxes = false;
      $scope.selectAllPrintQueues = { selected: false };
      $scope.orderByValue = 'info.name';
      $scope.orderByText = 'Name';
      $scope.reverse = false;
      $scope.searchPattern = '';
      $scope.groupsEnabled = false;
      $scope.selectedPrintQueues = 0;

      $scope.changeOrderByValue = function (value, textValue) {
        if (!angular.equals($scope.orderByValue, value)) {
          $scope.reverse = false;
        } else {
          $scope.reverse = !$scope.reverse;
        }
        $scope.orderByValue = value;
        $scope.orderByText = textValue;
      };

      $scope.isPrintQueuePassingSearchPattern = function (printQueue) {
        if (!printQueue) {
          return false;
        }
        if (!$scope.searchPattern) {
          return true;
        }
        if (printQueue) {
          let foundByModelName = false;
          if (printQueue.info.name) {
            foundByModelName = printQueue.info.name.toLowerCase().indexOf($scope.searchPattern.toLowerCase()) !== -1;
          }
          if (foundByModelName) {
            return true;
          }
        }
        return false;
      };

      $scope.selectAllQueues = function () {
        angular.forEach($scope.printerOriginal.resources.queues, function (value) {
          value.options.isSelected = $scope.selectAllPrintQueues.selected;
        });
      };

      $scope.$watch(function () {
        return $scope.printerOriginal;
      }, function () {
        if ($scope.printerOriginal) {
          $scope.selectedPrintQueues = $scope.printerOriginal.resources.queues
            .findAllElements($scope.isPrintQueuePassingSearchPattern).findAllElements({
              options: {
                isSelected: true
              }
            }).length;
          if (!$scope.selectedPrintQueues) {
            $scope.selectAllPrintQueues.selected = false;
          } else {
            $scope.selectAllPrintQueues.selected = ($scope.selectedPrintQueues === $scope.printerOriginal.resources.queues.length);
          }
        }
      }, true);

      $scope.deletePrintQueue = function (printQueue) {
        if (printQueue) {
          $ngBootbox.confirm($filter('stringular')($filter('translate')('DeletePrintQueue'), printQueue.info.name)).then(function () {
            $scope.printerOriginal.deletePrintQueue(printQueue).then(function () {
              toastr.success($filter('stringular')($filter('translate')('PrintQueueDeleted'), printQueue.info.name));
            }).catch(function(error) {});
          }).catch(function(error) {});
        } else {
          throw String('$scope.deletePrintQueue: printQueue is missing');
        }
      };

      $scope.deleteSelectedPrintQueues = function () {
        $scope.showSection = 'queues';
        if ($scope.printerOriginal.resources.queues.length > 0) {
          const searchCriteriaObject = {
            options: {
              isSelected: true
            }
          };
          const printQueueList = $scope.printerOriginal.resources.queues.findAllElements(searchCriteriaObject);
          if (printQueueList.length > 0) {
            const printQueueName = printQueueList[0].info.name;
            let message = '';
            if (printQueueList.length < 2) {
              message = $filter('stringular')($filter('translate')('DeletePrintQueue'), printQueueName);
            } else {
              message = $filter('stringular')($filter('translate')('DeletePrintQueues'), printQueueList.length);
            }
            $ngBootbox.confirm(message).then(function () {
              PrintQueueListService.bathcDeletePrintQueues(printQueueList, 'DELETE', 'PRINT_QUEUES_DELETE_BATCH').then(function (reponse) {
                let message = '';
                if (printQueueList.length < 2) {
                  message = $filter('stringular')($filter('translate')('PrintQueueDeleted'), printQueueList[0].info.name);
                } else {
                  message = $filter('stringular')($filter('translate')('PrintQueuesDeleted'), printQueueList.length);
                }
                toastr.success(message);
              }).catch(function(error) {});
            }).catch(function(error) {});

          } else {
            toastr.error($filter('translate')('SelectPrintQueueNone') + ', ' + $filter('translate')('SelectPrintQueue'));
          }
        } else {
          toastr.error($filter('translate')('SelectPrintQueueNone'));
        }
      };

      $scope.editSelectedPrintQueues = function (printQueue) {
        if ($scope.printerOriginal.resources.queues && $scope.printerOriginal.resources.queues.length > 0) {
          const selectedItems = $scope.printerOriginal.resources.queues.findAllElements({
            options: {
              isSelected: true
            }
          });
          if (printQueue || selectedItems.length === 1) {
            if (!printQueue) {
              printQueue = selectedItems[0];
            }
            $location.path(`printQueueProperties/${printQueue.printerId}/${printQueue.customProperties.id}`).search(URL_PARAMS.SHOW_QUEUE_SECTION.ROUTE, 'setup');

          } else {
            if (selectedItems.length > 1) {
              var idArray = [];
              angular.forEach(selectedItems, function(printQueueToEdit) {
                var urlReference = printQueueToEdit.info._links.self.href.split('printers/')[1];
                var printerId = urlReference.split('/queues/')[0];
                var queueId = urlReference.split('/queues/')[1];
                var pairedId = `${printerId}:${queueId}`;
                idArray.push(pairedId);
              });
              var url = URLS.PRINT_QUEUE_PROPERTIES_MULTI.replace(URL_PARAMS.PRINT_QUEUE_URL.LOCATION, idArray);
              $location.path(url).search({printerSection: "queues" });
            } else {
              throw String('$scope.editSelectedPrintQueue: printQueue is missing and there is no printQueue selected');
            }
          }
        }
      };

      $scope.createPrintQueue = function () {
        angular.element('#createQueueDialog').modal('show');
        $scope.createQueue = {
          active: true,
          name: ''
        };
      };

      $scope.checQueuekName = function () {
        if ($scope.createQueue.name.match(/[\\,]/)) {
          $scope.queueNameInvalid = true;
        } else {
          $scope.queueNameInvalid = false;
        }
      };

      $scope.confirmCreateQueue = function () {
        $scope.printerOriginal.createPrintQueue({
          name: $scope.createQueue.name,
          active: $scope.createQueue.active
        }).then(function () {
          $scope.showSection = 'queues';
          toastr.success($filter('stringular')($filter('translate')('PrintQueueCreated'), $scope.createQueue.name));
        }).catch(function(error) {});
      };

      $scope.cancelCreateQueueDialog = function () {
        $scope.createQueue.active = true;
        $scope.createQueue.name = '';
      };

      $scope.$watch(function () {
        return TenantListService.currentTenant;
      }, function () {
        if (TenantListService.currentTenant && TenantListService.currentTenant.info && TenantListService.currentTenant.info.groupsEnabled) {
          $scope.groupsEnabled = true;
        } else {
          $scope.groupsEnabled = false;
        }
      }, true);

      // POPUPS
      $scope.printerNamePopup = function (event) {
        event.stopPropagation();
        $scope.clearPopups();
        $scope.printerNameConfiguration = {
          selectDataObject: {
            listRaw: angular.copy($scope.namesArray),
            placeholderText: 'Select',
            label: 'PrinterNameSuggestions',
            keyIdentifier: 'printerName'
          },
          inputDataObject: [
            {
              label: 'PrinterName',
              placeholder: 'PrinterName',
              type: 'input',
              keyIdentifier: 'printerName',
              value: $scope.printer.info.name,
              focus: true,
              allowEmptyInput: false,
              maxLength: 255,
              regex: null
            }
          ]

        };
        $scope.printerNamePopupObject = {
          dimensions: { height: 255, width: 400 },
          offset: { top: 22, left: 57 },
          pointerDirection: null,
          pointerPosition: 'right',
          relativePosition: 'under',
          absoluteX: event.clientX,
          absoluteY: event.clientY,
          type: 'COMBINED_SELECT_INPUT',
          title: 'ModifyPrinterName',
          confirmText: 'Save',
          clickOutsideToClose: true,
          noPointer: true
        };
      };

      $scope.printerLocationPopup = function (event) {
        event.stopPropagation();
        $scope.clearPopups();
        $scope.printerLocationConfiguration = {
          inputDataObject: [
            {
              label: 'Location',
              placeholder: 'Location',
              maxLength: 255,
              type: 'input',
              keyIdentifier: 'printerLocation',
              value: $scope.printer.info.location,
              focus: true,
              allowEmptyInput: true,
              regex: null
            }
          ]
        };
        $scope.printerLocationPopupObject = {
          dimensions: { height: 175, width: 400 },
          offset: { top: 22, left: 57 },
          pointerDirection: null,
          pointerPosition: 'right',
          relativePosition: 'under',
          absoluteX: event.clientX,
          absoluteY: event.clientY,
          type: 'SIMPLE_INPUT',
          title: 'ModifyLocation',
          confirmText: 'Save',
          clickOutsideToClose: true
        };
      };

      $scope.printerAddressPopup = function (event) {
        event.stopPropagation();
        $scope.clearPopups();
        $scope.printerAddressConfiguration = {
          inputDataObject: [
            {
              label: 'PrinterAddress',
              placeholder: 'PrinterAddress',
              type: 'input',
              keyIdentifier: 'printerAddress',
              value: $scope.printer.info.ipAddress,
              focus: true,
              allowEmptyInput: false,
              regex: 'numeric'
            }
          ]
        };
        $scope.printerAddressPopupObject = {
          dimensions: { height: 175, width: 400 },
          offset: { top: 36, left: 57 },
          pointerDirection: null,
          pointerPosition: 'right',
          relativePosition: 'under',
          absoluteX: event.clientX,
          absoluteY: event.clientY,
          type: 'SIMPLE_INPUT',
          title: 'ModifyPrinterAddress',
          confirmText: 'Save',
          clickOutsideToClose: true
        };
      };

      $scope.networkSelectPopup = function (event) {
        event.stopPropagation();
        $scope.clearPopups();

        $scope.networkListPaging.pagingCriteria.pageSize = 5;
        $scope.networkListPaging.pagingCriteria.match = null;

        $scope.networkSelectConfiguration = {
          paginationObject: $scope.networkListPaging,
          placeholderText: 'Search',
          service: 'NetworkListService',
          contentHeight: 463
        };

        $scope.networkSelectPopupObject = {
          dimensions: { height: 463, width: 400 },
          offset: { top: 36, left: 60 },
          pointerDirection: 'down',
          pointerPosition: 'right',
          relativePosition: 'over',
          absoluteX: event.clientX,
          absoluteY: event.clientY,
          context: 'selectNetwork',
          type: 'PAGINATION',
          title: 'SelectNetwork',
          confirmText: 'SelectNetwork',
          clickOutsideToClose: true
        };
      };

      $scope.snmpSelectPopup = function (event) {
        event.stopPropagation();
        $scope.clearPopups();

        $scope.snmpConfigurationSelectConfiguration = {
          network: $scope.selectedNetwork || null
        };

        $scope.snmpConfigurationSelectPopupObject = {
          dimensions: { width: 400 },
          offset: { top: 0, left: 0 },
          pointerPosition: 'right',
          relativePosition: 'under',
          absoluteX: event.clientX,
          absoluteY: event.clientY,
          context: 'selectSnmpConfiguration',
          type: 'SELECT_SNMP',
          title: 'SelectSnmpConfiguration',
          confirmText: 'SelectSnmpConfiguration',
          clickOutsideToClose: true
        };
      };

      $scope.showNfcTagDeleteWarning = function (event) {
        event.stopPropagation();
        $scope.clearPopups();

        $scope.nfcTagDeleteWarning = {
          confirm: 'Yes',
          warning: null,
          danger: true,
          cancel: 'No',
          validationString: null
        };

        $scope.nfcTagDeleteWarningPopupObject = {
          dimensions: { height: 100, width: 250 },
          offset: { top: 36, left: 10 },
          pointerDirection: null,
          pointerPosition: 'left',
          relativePosition: 'over',
          absoluteX: event.clientX,
          absoluteY: event.clientY,
          type: 'CONFIRM',
          title: 'Delete',
          confirmText: null
        };
      };

      $scope.clearPopups = function () {
        $scope.nfcTagDeleteWarningPopupObject = null;
        $scope.nfcTagDeleteWarning = null;

        $scope.printerNamePopupObject = null;
        $scope.printerNameConfiguration = null;

        $scope.printerLocationPopupObject = null;
        $scope.printerLocationConfiguration = null;

        $scope.printerAddressPopupObject = null;
        $scope.printerAddressConfiguration = null;

        $scope.networkSelectPopupObject = null;
        $scope.networkSelectConfiguration = null;

        $scope.printerGeolocationPopupObject = null;
        $scope.printerGeolocationConfiguration = null;

        $scope.snmpConfigurationSelectPopupObject = null;
        $scope.snmpConfigurationSelectConfiguration = null;
      };

      $scope.copyIpAddress = function (ipAddress) {
        if (!ipAddress.startsWith('\\\\')) {
          ipAddress = ipAddress.split(' ')[0];
        }
        const input = document.createElement('input');
        input.setAttribute('value', ipAddress);
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        toastr.success($filter('translate')('CopyToClipboard'));
      };

      $scope.copyToClipboard = function (text) {
        if (text) {
          navigator.clipboard.writeText(text)
            .then(function () {
              toastr.success($filter('translate')('CopyToClipboard'));
            })
            .catch(function () {
            });
        }
      };

      $scope.savePrinter = function (printerItem) {
        let printerItemArray = [];
        if (angular.isArray(printerItem)) {
          printerItemArray = printerItem;
        } else {
          printerItemArray.push(printerItem);
        }

        if (printerItem) {

          switch (printerItemArray[0].keyIdentifier) {
            case 'printerName':
              $scope.printer.info.name = printerItem.value;
              break;
            case 'printerLocation':
              $scope.printer.info.location = printerItem.value;
              break;
            case 'printerAddress':
              $scope.printer.info.ipAddress = printerItem.value;
              break;
            case 'printerGeoLocationLat':
              if (!$scope.printer.info.geoLocation) {
                $scope.printer.info.geoLocation = {};
              }
              $scope.printer.info.geoLocation.lat = printerItem[0].value;
              $scope.printer.info.geoLocation.lon = printerItem[1].value;
              break;
            case '':
              break;
          }
        }

        $scope.printerOriginal.saveChanges($scope.printer).then(function (response) {
          toastr.success($filter('translate')('ChangesSaved'));
        }).catch(function(error) {});
      };

      $scope.deleteNfcTag = function () {
        delete $scope.printer.info.nfcTag;
        $scope.savePrinter();
      };

      $scope.isVirtualPrinter = function () {
        if ($scope.printer) {
          return $scope.printer.info.type === PRINTER_TYPES.VIRTUAL;
        }
      };

      function getDefaultSnmpConfiguration() {
        SnmpConfigurationService.getDefaultSnmpConfiguration().then(function (defaultSnmpConfiguration) {
          $scope.defaultSnmpConfiguration = defaultSnmpConfiguration;
        }).catch(function(error) {});
      }

      function checkAndFixSnmpConfiguration() {
        if (!$scope.isVirtualPrinter() && (!$scope.printer.info._embedded.snmpConfiguration || !isSnmpConfigurationValidForNetwork())) {
          setSnmpConfigurationToDefault();
        }
      }

      function isSnmpConfigurationValidForNetwork() {
        const snmp = $scope.printer.info._embedded.snmpConfiguration;
        if (!snmp || !snmp.networkIds || !snmp.networkIds.length) {
          return true;
        }
        const network = $scope.selectedNetwork;
        if (network && snmp.networkIds.includes(network.customProperties.id)) {
          return true;
        }
        return false;
      }

      function setSnmpConfigurationToDefault() {
        if ($scope.defaultSnmpConfiguration) {
          $scope.changePrinterSnmpConfiguration($scope.defaultSnmpConfiguration);
        }
      }

      $scope.changePrinterNetwork = function (network) {
        $scope.printerOriginal.changePrinterNetwork(network).then(function (response) {
          toastr.success($filter('translate')('ChangesSaved'));
          checkAndFixSnmpConfiguration();
        }).catch(function(response) {
          toastr.error($filter('translate')('ERROR'));
        });
      };

      $scope.changePrinterSnmpConfiguration = function (snmpConfig) {
        $scope.printer.info.snmpConfiguration = snmpConfig.info._links.self.href;
        $scope.printerOriginal.saveChanges($scope.printer).then(function (response) {
          toastr.success($filter('translate')('ChangesSaved'));
        }).catch(function (response) {
          toastr.error($filter('translate')('ERROR'));
        });
      };

      $scope.getNetworkUrl = function () {
        if ($scope.selectedNetwork) {
          const networkId = $scope.selectedNetwork.info._links.self.href.split('/').pop()
          return '/admin/#' + URLS.NETWORK_PROPERTIES.replace(URL_PARAMS.NETWORK_ID.LOCATION, networkId);
        } else {
          return '';
        }
      };

      $scope.getSnmpConfigurationUrl = function () {
        const snmpId = $scope.printer.info._embedded.snmpConfiguration._links.self.href.split('/').pop();
        const url = '/admin/#' + URLS.SNMP_CONFIGURATION_PROPERTIES.replace(URL_PARAMS.SNMP_CONFIG_URL.LOCATION, snmpId);
        return url;
      };

      function getPrinter() {
        const additionalEmbbed = ',cardReaders';
        PrinterListService.getPrinterById($routeParams[URL_PARAMS.PRINTER_URL.ROUTE], additionalEmbbed).then(function (printer) {
          $scope.printerOriginal = printer;
          $scope.printer = angular.copy(printer);
          if ($scope.printer.info._links['px:network']) {
            const networkId = $scope.printer.info._links['px:network'].href.split('networks/');

            NetworkListService.getNetworkById(networkId[1]).then(function (network) {
              isThisResourceMine(network);
              $scope.selectedNetwork = network;
              $scope.statusPrinter = {
                printer: $scope.printer,
                networks: network,
                currentTenant: TenantListService.currentTenant
              };
              checkAndFixSnmpConfiguration();
            }).catch(function(error) {});
          }

          getNameSuggestions();
          if ($scope.printer.info.geoLocation) {
            $scope.getLocationEnabled = true;
          }
          $rootScope.secondaryHeadline = $scope.printer.info.name;
        }).catch(function(error) {});
      }

      function isThisResourceMine(network) {
        const siteUrl = network.info._links['px:site'] ? network.info._links['px:site'].href : null;
        $scope.isThisResourceMine = $scope.me.isThisSiteMine(siteUrl);
      }

      /// /////////////////////////////////
      /// /////////////////////////////////
      /// ///  Open context menu
      /// /////////////////////////////////
      $scope.openContext = function (event, context, menuOption) {
        $scope.closeAllMenues();
        $timeout(function  () {
          $scope.selectedContextMenuItem  =  menuOption;
          $scope.contextContentPosition = { left: event.clientX, top: event.clientY };
          $scope.contextPosition = { left: event.clientX, top: event.clientY };
          $scope.contextContent = context;
          $scope.context = context;
          $scope.auxiliaries = {
            tenant: currentTenant,
            enums: enums,
            me: $scope.me
          };
        }, 50);
      };

      $scope.closeAllMenues = function () {
        $scope.menuContent = null;
        $scope.menuSpecs = null;
        $scope.selectedContextMenuItem = null;
        $scope.contextContentPosition = null;
        $scope.contextPosition = null;
        $scope.contextContent = null;
        $scope.context = null;
        $scope.auxiliaries = null;
      };

      function setListeners() {

        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.BATCH_EXECUTED, function (name, data) {
          if (data.reference === 'PRINT_QUEUES_DELETE_BATCH') {
            getPrinter();
          }
        });

        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_UPDATE, function (name, data) {
          if (data.printer === $scope.printer.info._links.self.href) {
            getPrinter();
          }
        });

        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_REMOVED, function (name, data) {
          if (data.printer === $scope.printer.info._links.self.href) {
            $location.path(URLS.PRINTER_LIST);
          }
        });

        $scope.$on('REQUEST_ERROR', (name, data) => {
          $scope.error = data.error;
        });

      }

      $scope.clearError = () => {
        // $scope.closeAllMenues()
        $scope.error = null;
      };

      /// /////////////////////////////////////////
      /// /////////////////////////////////////////
      // TOOLTIP STUFF
      /// /////////////////////////////////////////
      $scope.showTooltip = function (showTip, position, tooltipScope, context) {
        if (showTip) {
          switch (tooltipScope) {
            case 'statement':
              statementTooltip(position, context);
              break;
          }
        } else {
          $scope.clearTooltip();
        }
      };

      function statementTooltip(position, title) {

        $scope.clearTooltip();
        $scope.tooltipContent = {
          title: title,
          type: 'statement'
        };

        $scope.tooltipObject = {
          position: { left: position.startX, top: position.startY + 20 }
        };
      }

      $scope.clearTooltip = function () {
        $scope.tooltipContent = null;
        $scope.tooltipObject = null;
      };

    });
})();
